exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".print-only[data-v-aa020724] {\n  display: none;\n  text-align: justify;\n}\na[data-v-aa020724] {\n  font-size: 0.8rem;\n  cursor: s-resize;\n}\na.expanded[data-v-aa020724] {\n  cursor: n-resize;\n}\n@media print {\n.print-only[data-v-aa020724] {\n    display: block;\n}\n.screen-only[data-v-aa020724] {\n    display: none;\n}\n}", ""]);

// exports
